import React, { useEffect, useMemo, useState, useRef } from "react";
import { useForm } from "react-hook-form";
import { Button } from "primereact/button";
import EzControlledDropDowntWithFloatingLabel from "../../../../common/EzForm/EzControlledDropDown/WithFloatingLabel";
import "./styles.css";
import Breadcrumb from "../../../../common/Breadcrumb";
import { useStyles } from "../style";
import {
  AppliesDD,
  basicDetail,
  editMode,
  statusDD,
} from "../CreateRateAdminNetworks/constant";
import { Container, Grid } from "@mui/material";
import EzControlledInputWithFloatingLabel from "../../../../common/EzForm/EzControlledInput/WithFloatingLabel";
import { EzToast, TOAST_SEVERITY } from "../../../../common/EzToast";
import { useNavigate } from "react-router-dom";
import { APP_URLS } from "../../../../utils/constant";
import { RateAdminBreadcrumb } from "../../RateAdminRateCode/CreateRateAdminRateCode/constant";
import EzControlledCheckBoxWithLabel from "../../../../common/EzForm/EzControlledCheckBox/WithLabel";
import { getFormBaseValidationRule } from "../../../../utils/form/form-utils";
import { hasAllMenuPermissions } from "../../../../utils/common";
import EzControlledMultiSelecttWithFloatingLabel from "../../../../common/EzForm/EzControlledMultiSelect/WithFloatingLabel";
import NetworkCredentialsDialog from "../NetworkCredentialsDialog";

const CreateRateAdminNetworksComponent = (props) => {
  const navigate = useNavigate();
  const {
    initCreateRateAdminNetworksScreen,
    createRateAdminNetworks,
    editRateAdminNetworks,
    isLoading,
    isRateAdminNetworksCreateSuccess,
    isRateAdminNetworksDetailSuccess,
    isRateAdminNetworksEditSuccess,
    isEdit,
    formFieldValueMap,
    shouldBlockNavigation,
    locationDD,
    vehicleCategoryDD,
    switchDefaultNetwork,
    fetchNetworkCredentials,
    updateNetworkCredentials,
    fetchNetworkAuditTrail,
    networkCredentials,
    auditTrailList,
    auditTrailPaginationInfo,
    isNetworkCredentialsSuccess,
    isUpdateNetworkCredentialsSuccess,
  } = props;

  console.log("check props of component", props);

  const classes = useStyles();

  const {
    control,
    formState: { errors, isDirty },
    watch,
    resetField,
    setValue,
    handleSubmit,
    reset,
  } = useForm({
    defaultValues: useMemo(() => {
      console.log("check value come or not", formFieldValueMap);
      return formFieldValueMap;
    }, [formFieldValueMap]),
  });

  useEffect(() => {
    if (!isRateAdminNetworksCreateSuccess && !isRateAdminNetworksEditSuccess) {
      shouldBlockNavigation(isDirty);
    }
  }, [isDirty, shouldBlockNavigation, isRateAdminNetworksCreateSuccess, isRateAdminNetworksEditSuccess]);

  const navigateToRateAdminNetworksScreen = () => {
    navigate(APP_URLS.RATEADMIN_NETWORK.HOME);
  };

  useEffect(() => {
    if (isRateAdminNetworksCreateSuccess) {
      reset();
    }
  }, [isRateAdminNetworksCreateSuccess, reset]);

  useEffect(() => {
    initCreateRateAdminNetworksScreen();
  }, [initCreateRateAdminNetworksScreen]);

  const [typeInsurance_1, setTypeInsurance_1] = useState("");
  const [typeInsurance_2, setTypeInsurance_2] = useState("");
  const skipApplicableReset = useRef(false);

  const [showCredentialsDialog, setShowCredentialsDialog] = useState(false);
  const [toastConfig, setToastConfig] = useState({
    severity: TOAST_SEVERITY.SUCCESS,
    toastTitle: "",
    shouldShowToast: false,
  });

  const applicable = watch("applicable");
  
  const canShowNetworkCredentialButton = hasAllMenuPermissions(
    "networkPasswordResetMenu",
    ["create", "edit", "view"]
  );

  const clearField = (name) => setValue(name, "");

  const handleRadio = (e) => {
    const { name, value } = e.target;
    if (name === "typeInsurance_1") {
      setTypeInsurance_1(value);
      clearField("rateDayPercentage_1_1");
      clearField("rateDayPercentage_1_2");
      clearField("rateDayPercentage_2_1");
      clearField("rateDayPercentage_2_2");
    } else {
      setTypeInsurance_2(value);
      clearField("rateDayPercentage_1_1");
      clearField("rateDayPercentage_1_2");
      clearField("rateDayPercentage_2_1");
      clearField("rateDayPercentage_2_2");
    }
  };

  const [inclusiveRate, setInclusiveRate] = useState(false);

  const handleCheckbox = (e) => {
    const { checked } = e.target;
    setInclusiveRate(checked);
    if (!checked) {
      setValue("applicable", "");
      clearField("rateDayPercentage_1_1");
      clearField("rateDayPercentage_1_2");
      clearField("rateDayPercentage_2_1");
      clearField("rateDayPercentage_2_2");
      setTypeInsurance_1("");
      setTypeInsurance_2("");
    }
  };

  useEffect(() => {
    if (isRateAdminNetworksDetailSuccess) {
      skipApplicableReset.current = true;
      reset({ ...formFieldValueMap });
      setInclusiveRate(formFieldValueMap?.inclusiveRate === 1);

      const nval2 =
        Number(formFieldValueMap?.applicable) === 2
          ? String(formFieldValueMap?.typeInsurance)
          : "";
      setTypeInsurance_2(nval2);
      const nval =
        Number(formFieldValueMap?.applicable) === 1
          ? String(formFieldValueMap?.typeInsurance)
          : "";
      setTypeInsurance_1(nval);
    }
  }, [isRateAdminNetworksDetailSuccess, formFieldValueMap, reset]);

  useEffect(() => {
    if (isRateAdminNetworksEditSuccess && formFieldValueMap) {
      const app = Number(formFieldValueMap?.applicable);
      const typeIns = String(formFieldValueMap?.typeInsurance);
      const rate = formFieldValueMap?.rateDayPercentage;

      reset({
        ...formFieldValueMap,
        rateDayPercentage_1_1: app === 1 && typeIns === "1" ? rate : "",
        rateDayPercentage_1_2: app === 1 && typeIns === "2" ? rate : "",
        rateDayPercentage_2_1: app === 2 && typeIns === "1" ? rate : "",
        rateDayPercentage_2_2: app === 2 && typeIns === "2" ? rate : "",
      });

      setTypeInsurance_1(app === 1 ? typeIns : "");
      setTypeInsurance_2(app === 2 ? typeIns : "");
    }
  }, [isRateAdminNetworksEditSuccess, formFieldValueMap, reset]);

  useEffect(() => {
    if (skipApplicableReset.current) {
      skipApplicableReset.current = false;
      return;
    }
    if (applicable !== undefined) {
      setValue("rateDayPercentage_1_1", "");
      setValue("rateDayPercentage_1_2", "");
      setValue("rateDayPercentage_2_1", "");
      setValue("rateDayPercentage_2_2", "");
      setTypeInsurance_1("");
      setTypeInsurance_2("");
    }
  }, [applicable, setValue]);

  const onSubmit = (data) => {

    const currentTypeInsurance = typeInsurance_1 || typeInsurance_2 || 
      (isEdit && Number(formFieldValueMap?.applicable) === Number(data?.applicable) 
        ? String(formFieldValueMap?.typeInsurance) 
        : null);

    const stringifiedData = {
      id: isEdit ? data?.id : null,
      userId: localStorage.getItem("userId"),
      applicable: data?.applicable,
      inclusiveRate: inclusiveRate === true ? 1 : 0,
      locationId: data?.locationId,
      status: data?.status,
      title: data?.title,
      prefix: data?.prefix,
      rateDayPercentage:
        (applicable === 1 && typeInsurance_1 === "1" ? data?.rateDayPercentage_1_1 : null) ||
        (applicable === 1 && typeInsurance_1 === "2" ? data?.rateDayPercentage_1_2 : null) ||
        (applicable === 2 && typeInsurance_2 === "1" ? data?.rateDayPercentage_2_1 : null) ||
        (applicable === 2 && typeInsurance_2 === "2" ? data?.rateDayPercentage_2_2 : null) ||
        null,
      typeInsurance: currentTypeInsurance,
      url: data?.url,
      vehicleCategoryId: data?.vehicleCategoryId,
    };

    if (isEdit) {
      editRateAdminNetworks({ id: data.id, data: stringifiedData });
    } else {
      createRateAdminNetworks(stringifiedData);
    }
  };

  const getToastProps = () => {
    return toastConfig;
  };

  const getFormErrorMessage = (name) => {
    return (
      errors[name] && <small className="p-error">{errors[name].message}</small>
    );
  };

  const handleSwitchDefaultNetwork = () => {
    if (formFieldValueMap?.id) {
      switchDefaultNetwork({ networkId: formFieldValueMap.id });
    }
  };

  const handleOpenCredentialsDialog = () => {
    if (!formFieldValueMap?.id) {
      setToastConfig({
        severity: TOAST_SEVERITY.ERROR,
        toastTitle: "Please save the network first before adding credentials",
        shouldShowToast: true,
      });
      return;
    }
    setShowCredentialsDialog(true);
  };

  const handleCloseCredentialsDialog = () => {
    setShowCredentialsDialog(false);
  };

  const renderPageHeaderSection = () => {
    return (
      <div className="make-relative sub-header ">
        <div className="maintitlediv">
          <div className="ml-3">
            <h4 className="pagetitle">{isEdit ? "Update Network" : "Create Network"}</h4>
          </div>
          <div className="buttonarea">
            {isEdit && canShowNetworkCredentialButton && (
              <Button
                tooltip={"Update network credential"}
                label={"Update network credential"}
                className="p-button"
                style={{ borderRadius: "10px" }}
                onClick={handleOpenCredentialsDialog}
                type="button"
              />
            )}
            {isEdit && (
              <Button
                tooltip={"Make as Default Network"}
                label={"Make as Default Network"}
                className={`p-button`}
                style={{ borderRadius: "10px" }}
                onClick={handleSwitchDefaultNetwork}
                type="button"
              />
            )}
            <Button
              tooltip={"Back to Networks"}
              tooltipOptions={{ position: "left" }}
              label={"Back to Networks"}
              className={`p-button `}
              style={{ borderRadius: "10px" }}
              onClick={navigateToRateAdminNetworksScreen}
            />
          </div>
        </div>
      </div>
    );
  };

  return (
    <Container maxWidth="lg">
      <Breadcrumb list={RateAdminBreadcrumb} />
      <EzToast {...getToastProps()} />
      <div className={`containerbox ${classes.bg}`}>
        {renderPageHeaderSection()}
        <div className="form-demo">
          <form onSubmit={handleSubmit(onSubmit)} className="p-fluid">
            <Grid container spacing={2}>
              {basicDetail?.map((item) =>
                item.name === "status" ? (
                  <Grid item xs={12} sm={6} md={4} lg={3} key={item.name}>
                    <EzControlledDropDowntWithFloatingLabel
                      name={item?.name}
                      control={control}
                      rules={item?.rule}
                      optionLabel={"name"}
                      optionValue={"id"}
                      options={statusDD}
                      isError={errors[item?.name]}
                      errorMsg={getFormErrorMessage(item?.name)}
                      label={item?.label}
                      labelClassName={"ml-2"}
                    />
                  </Grid>
                ) : item.name === "locationId" ? (
                  <Grid item xs={12} sm={6} md={4} lg={3} key={item.name}>
                    <EzControlledMultiSelecttWithFloatingLabel
                      name={item?.name}
                      control={control}
                      rules={item?.rule}
                      optionLabel={"name"}
                      optionValue={"id"}
                      options={locationDD}
                      isError={errors[item?.name]}
                      errorMsg={getFormErrorMessage(item?.name)}
                      label={item?.label}
                      labelClassName={"ml-2"}
                    />
                  </Grid>
                ) : item.name === "vehicleCategoryId" ? (
                  <Grid item xs={12} sm={6} md={4} lg={3} key={item.name}>
                    <EzControlledMultiSelecttWithFloatingLabel
                      name={item?.name}
                      control={control}
                      rules={item?.rule}
                      optionLabel={"name"}
                      optionValue={"id"}
                      options={vehicleCategoryDD}
                      isError={errors[item?.name]}
                      errorMsg={getFormErrorMessage(item?.name)}
                      label={item?.label}
                      labelClassName={"ml-2"}
                    />
                  </Grid>
                ) : item.name === "applicable" ? (
                  <Grid item xs={12} sm={6} md={4} lg={3} key={item.name}>
                    <EzControlledDropDowntWithFloatingLabel
                      name={item?.name}
                      control={control}
                      disabled={!inclusiveRate}
                      rules={item?.rule}
                      optionLabel={"name"}
                      optionValue={"id"}
                      options={AppliesDD}
                      isError={errors[item?.name]}
                      errorMsg={getFormErrorMessage(item?.name)}
                      label={item?.label}
                      labelClassName={"ml-2"}
                    />
                  </Grid>
                ) : item.name === "inclusiveRate" ? (
                  <Grid item xs={12} sm={6} md={4} lg={3} mb={2} key={item.name}>
                    <EzControlledCheckBoxWithLabel
                      name={item.name}
                      value={inclusiveRate}
                      id={item.name}
                      control={control}
                      isError={errors[item.label]}
                      label={item.label}
                      labelClassName={"ml-2 mb-2"}
                      onChange={handleCheckbox}
                    />
                  </Grid>
                ) : (
                  <Grid item xs={12} sm={6} md={4} lg={3} key={item.name}>
                    <EzControlledInputWithFloatingLabel
                      name={item?.name}
                      control={control}
                      label={item?.label}
                      type={item?.type}
                      rules={item?.rule}
                      isError={errors[item?.name]}
                      errorMsg={getFormErrorMessage(item?.name)}
                    />
                  </Grid>
                )
              )}
            </Grid>
            {applicable === 1 && (
              <Grid container>
                <Grid
                  item
                  alignItems={"center"}
                  textAlign={"center"}
                  paddingTop={"10px"}
                  marginRight={"10px"}
                >
                  <input
                    checked={typeInsurance_1 === "1"}
                    type="radio"
                    onChange={handleRadio}
                    name="typeInsurance_1"
                    value="1"
                  />
                </Grid>
                <Grid item xs={8} sm={6} md={4} lg={3}>
                  <EzControlledInputWithFloatingLabel
                    name={"rateDayPercentage_1_1"}
                    labelClassName={"ml-4"}
                    control={control}
                    label="LDW ($1500 deductible)"
                    type="text"
                    disabled={typeInsurance_1 !== "1"}
                    rules={getFormBaseValidationRule().DEFAULT.DO_NOT_VALIDATE}
                    isError={errors["rateDayPercentage_1_1"]}
                    errorMsg={getFormErrorMessage("rateDayPercentage_1_1")}
                  />
                </Grid>
                <Grid alignItems={"center"} paddingTop={"10px"} marginLeft={"10px"}>
                  / Day
                </Grid>
                <Grid alignItems={"center"} textAlign={"center"} item xs={2} paddingTop={"10px"}>
                  OR
                </Grid>
                <Grid
                  item
                  alignItems={"center"}
                  textAlign={"center"}
                  paddingTop={"10px"}
                  marginRight={"10px"}
                >
                  <input
                    checked={typeInsurance_1 === "2"}
                    type="radio"
                    onChange={handleRadio}
                    name="typeInsurance_1"
                    value="2"
                  />
                </Grid>

                <Grid item xs={8} sm={6} md={4} lg={3}>
                  <EzControlledInputWithFloatingLabel
                    name={"rateDayPercentage_1_2"}
                    control={control}
                    label="LDW ($2500 deductible))"
                    type="text"
                    disabled={typeInsurance_1 !== "2"}
                    rules={getFormBaseValidationRule().DEFAULT.DO_NOT_VALIDATE}
                    isError={errors["rateDayPercentage_1_2"]}
                    errorMsg={getFormErrorMessage("rateDayPercentage_1_2")}
                  />
                </Grid>
                <Grid alignItems={"center"} paddingTop={"10px"} marginLeft={"10px"}>
                  / Day
                </Grid>
              </Grid>
            )}

            {applicable === 2 && (
              <Grid container>
                <Grid
                  item
                  alignItems={"center"}
                  textAlign={"center"}
                  paddingTop={"10px"}
                  marginRight={"10px"}
                >
                  <input
                    checked={typeInsurance_2 === "1"}
                    type="radio"
                    onChange={handleRadio}
                    name="typeInsurance_2"
                    value="1"
                  />
                </Grid>
                <Grid item xs={8} sm={6} md={4} lg={3}>
                  <EzControlledInputWithFloatingLabel
                    name={"rateDayPercentage_2_1"}
                    control={control}
                    label="LDW ($1500 deductible)"
                    type="text"
                    disabled={typeInsurance_2 !== "1"}
                    rules={getFormBaseValidationRule().DEFAULT.DO_NOT_VALIDATE}
                    isError={errors["rateDayPercentage_2_1"]}
                    errorMsg={getFormErrorMessage("rateDayPercentage_2_1")}
                  />
                </Grid>
                <Grid alignItems={"center"} paddingTop={"10px"} marginLeft={"10px"}>
                  % on total
                </Grid>
                <Grid alignItems={"center"} textAlign={"center"} item xs={2} paddingTop={"10px"}>
                  OR
                </Grid>
                <Grid
                  item
                  alignItems={"center"}
                  textAlign={"center"}
                  paddingTop={"10px"}
                  marginRight={"10px"}
                >
                  <input
                    checked={typeInsurance_2 === "2"}
                    type="radio"
                    onChange={handleRadio}
                    name="typeInsurance_2"
                    value="2"
                  />
                </Grid>

                <Grid item xs={8} sm={6} md={4} lg={3}>
                  <EzControlledInputWithFloatingLabel
                    name={"rateDayPercentage_2_2"}
                    control={control}
                    label="LDW ($2500 deductible)"
                    type="text"
                    disabled={typeInsurance_2 !== "2"}
                    rules={getFormBaseValidationRule().DEFAULT.DO_NOT_VALIDATE}
                    isError={errors["rateDayPercentage_2_2"]}
                    errorMsg={getFormErrorMessage("rateDayPercentage_2_2")}
                  />
                </Grid>
                <Grid alignItems={"center"} paddingTop={"10px"} marginLeft={"10px"}>
                  % on total
                </Grid>
              </Grid>
            )}
            <div className={"make-flex mt-3 mr-2"}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "end",
                }}
              >
                <React.Fragment>
                  <div style={{ margin: "15px 0px 15px 10px", minWidth: "100px" }}>
                    <Button
                      type="submit"
                      label={isEdit ? "Update" : "Save"}
                      className="mt-2 p-button-raised"
                    />
                  </div>
                </React.Fragment>
              </div>
            </div>
            {isEdit && (
              <Grid className="modsection" container spacing={2}>
                {editMode?.map((item) => (
                  <Grid item xs={3} key={item.name}>
                    <EzControlledInputWithFloatingLabel
                      name={item?.name}
                      control={control}
                      disabled={item?.disabled}
                      label={item?.label}
                      type={item?.type}
                      rules={item?.rule}
                      isError={errors[item?.name]}
                      errorMsg={getFormErrorMessage(item?.name)}
                    />
                  </Grid>
                ))}
              </Grid>
            )}
          </form>
        </div>
      </div>

      {/* Network Credentials Dialog - Separate Component */}
      <NetworkCredentialsDialog
        visible={showCredentialsDialog}
        onHide={handleCloseCredentialsDialog}
        networkId={formFieldValueMap?.id}
        networkCredentials={networkCredentials}
        auditTrailList={auditTrailList}
        auditTrailPaginationInfo={auditTrailPaginationInfo}
        isNetworkCredentialsSuccess={isNetworkCredentialsSuccess}
        isUpdateNetworkCredentialsSuccess={isUpdateNetworkCredentialsSuccess}
        isLoading={isLoading}
        fetchNetworkCredentials={fetchNetworkCredentials}
        updateNetworkCredentials={updateNetworkCredentials}
        fetchNetworkAuditTrail={fetchNetworkAuditTrail}
      />
    </Container>
  );
};

export default CreateRateAdminNetworksComponent;